// extracted by mini-css-extract-plugin
export default {"skip-button":"BatchUpdateResaleStatusAndArtistModal_skip-button__fmoIh"};